import { render, staticRenderFns } from "./GeneralConfig.vue?vue&type=template&id=ceb7c118"
import script from "./GeneralConfig.vue?vue&type=script&lang=js"
export * from "./GeneralConfig.vue?vue&type=script&lang=js"
import style0 from "./GeneralConfig.vue?vue&type=style&index=0&id=ceb7c118&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports